
// export const myGetter = ( state ) => {
//  return state
// }

export const staffersList = state => state.staffers
export const staffersSelectable = state => state.staffersSelectable
export const staffersPaginatedData = state => state.staffersPaginatedData
export const staffer = state => state.staffer
export const isLoading = state => state.isLoading
export const isCreating = state => state.isCreating
export const isUpdating = state => state.isUpdating
export const createdData = state => state.createdData
export const updatedData = state => state.updatedData
export const isDeleting = state => state.isDeleting
export const deletedData = state => state.deletedData